import {
  baseRequestWithAxiosResponse,
  baseRequestWithHeaders,
} from './base-request';
import axios from 'axios';
import config from '../../../config';
import { store } from '../../store';

export const fetchAllApprovalRequests = (params) => {
  const url = `practice/doctor-practice/all-approval-requests`;
  const method = 'GET';
  return baseRequestWithHeaders(url, method, params);
};

export const updateRequestStatus = (body) => {
  const url = `practice/doctor-practice/approval-status`;
  const method = 'POST';
  return baseRequestWithHeaders(url, method, null, body);
};

export const approveRequestStatus = (body) => {
  const url = `practice/doctor-practice`;
  const method = 'POST';
  return baseRequestWithHeaders(url, method, null, body);
};

export const updateDiscountForAllSpecialists = (body) => {
  const url = `practice/discount`;
  const method = 'PUT';
  return baseRequestWithHeaders(url, method, null, body);
};


export const doctorPracticeApproveRequestStatus = (body) => {
  const url = `doctors/doctor-practice/approval-status`;
  const method = 'POST';
  return baseRequestWithHeaders(url, method, null, body);
};

export const centerFulfilmentApproveRequestStatus = (body) => {
  const rootUrl = `${config.apiBaseUrl}`;
  const baseUrl = `${rootUrl}/network/`;
  const url = `${baseUrl}center-fulfilment/approval-status`;
  const method = 'POST';
  const headers = {};

  const state = store.getState();
  if (state.user.authToken) {
    headers.authorization = state.user.authToken;
  }

  return axios({
    url,
    method,
    headers,
    data: body,
  })
    .then((response) => {
      if (response && response.status === 200) {
        return {
          body: response.data,
          headers: response.headers,
        };
      }
      throw new Error('Status code is not ok');
    })
    .catch((err) => {
      console.error({ err }, 'Error in endpoint');
      throw err;
    });
};

export const centerFulfilmentCencelRequest = (body) => {
  const url = `center-fulfilment/status-cencel`;
  const method = 'POST';
  return baseRequestWithHeaders(url, method, null, body);
};

export const centerFulfilmentApproveRequest = (body) => {
  const url = `center-fulfilment/status-approve`;
  const method = 'POST';
  return baseRequestWithHeaders(url, method, null, body);
};